import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { computed, effect, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';

export const BREAKPOINTS = {
  web: '(min-width: 840px)',
  fullWeb: '(min-width: 980px)',
  smallWeb: '(min-width: 840px) and (max-width: 980px)',
  mobile: '(max-width: 840px)',
};

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private breakpointObs = inject(BreakpointObserver);
  private platform = inject(Platform);

  breaksObs$ = this.breakpointObs.observe([BREAKPOINTS.smallWeb]).pipe(startWith(null));
  isWeb$ = this.breakpointObs.observe(BREAKPOINTS.web).pipe(map((res) => res.matches));
  isWeb = toSignal(this.isWeb$);
  isSmallWeb = toSignal(this.breaksObs$.pipe(map(() => this.observer.isMatched(BREAKPOINTS.smallWeb))));
  isFullWeb$ = this.breakpointObs.observe(BREAKPOINTS.fullWeb).pipe(map((res) => res.matches));
  isFullWeb = computed(() => this.isWeb() && !this.isSmallWeb());
  isMobile = computed(() => !this.isWeb());

  isMenuOpen: WritableSignal<boolean> = signal(false);

  constructor(private observer: BreakpointObserver) {
    this.breaksObs$.subscribe((res) => {
      console.log({ aaaa: res });
    });

    this.breakpointObs
      .observe(BREAKPOINTS.web)
      .pipe(filter((res) => this.isMenuOpen() && res.matches))
      .subscribe(() => {
        this.isMenuOpen.set(false);
      });

    effect(() =>
      console.log({
        isWeb: this.isWeb(),
        isFullWeb: this.isFullWeb(),
        isSmallWeb: this.isSmallWeb(),
        isMobile: this.isMobile(),
      }),
    );
  }

  isPlatformMobile() {
    return this.platform.IOS || this.platform.ANDROID;
  }

  closeMenu() {
    this.isMenuOpen.set(false);
  }

  toggleMenu() {
    if (!this.isMenuOpen() && this.isWeb()) return;
    this.isMenuOpen.update((value) => !value);
  }
}
